import TrainingConstants from "../constants/training-constants";
import courseLibraryService from "../services/Training/course-library-service";
import internalCourseService from "../services/Training/internal-course-service";
import externalCourseService from "../services/Training/external-course-service";
// import newcomerTrainingService from "../services/Training/newcomer-training-service";


// course-library
function changeTrainingCourseAction (filters = {}, status = "loading", counter = 1) {
  return {
    type: TrainingConstants.ActionTypes.CHANGETRAININGCOURSE,
    payload: {
      counter: counter,
      filters: filters,
      status: status
    }
  }
}
export function changeTrainingCourse(filters = {}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeTrainingCourseAction(filters, status, counter))
}
export function selectTrainingCourse(gets) {
	return dispatch => courseLibraryService.selectTrainingCourse(gets, res => {
		if (200 === res.status) {
			res.data.Data.forEach(course => {
				// console.log(course);
				if ("内部培训" === course.training_type_name) {
					course.training_teacher_name = course.training_it_teacher_name;
				}
			})
			dispatch({
				type: TrainingConstants.ActionTypes.SELECTTRAININGCOURSE,
				payload: {
					status: "loaded",
					data: res.data
				}
			});
		}else{
			dispatch(changeTrainingCourseAction({}, "error", 0));
		}
	}, err => dispatch(changeTrainingCourseAction({}, "error", 0)))	
}

// internal-course
function changeInternalCourseAction (filters = {}, status = "loading", counter = 1) {
  return {
    type: TrainingConstants.ActionTypes.CHANGEINTERNALCOURSE,
    payload: {
      counter: counter,
      filters: filters,
      status: status
    }
  }
}
export function changeInternalCourse(filters ={}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeInternalCourseAction(filters, status, counter));
}
export function selectInternalCourse(gets) {
	return dispatch => {
		let dataReloaded = false;
		internalCourseService.selectInternalCourse(gets, res => {
			dataReloaded = true;
			if (200 === res.status) {
				dispatch({
					type: TrainingConstants.ActionTypes.SELECTINTERNALCOURSE,
					payload: {
						status: "loaded",
						data: res.data
					}
				});
			}else{
				dispatch(changeInternalCourseAction({}, "error", 0));
			}
		}, err => dispatch(changeInternalCourseAction({}, "error", 0)));
		setTimeout(() => {
			if (!dataReloaded) {
				dispatch(changeInternalCourseAction({}, "loading", 0));
			}
		}, 100);
	}
}
export function updateInternalCourse(puts, index, callback) {
	return dispatch => internalCourseService.updateInternalCourse(puts, res => {
		if (res.data.Success) {
			dispatch({
				type: TrainingConstants.ActionTypes.UPDATEINTERNALCOURSE,
				payload: {
					value: puts,
					index: index
				}
			});
		}
		if ("function" === typeof callback) {
			callback(res);
		}
	})
}


// external-course
function changeExternalCourseAction (filters ={}, status = "loading", counter = 1) {
  return {
    type: TrainingConstants.ActionTypes.CHANGEEXTERNALCOURSE,
    payload: {
      counter: counter,
      filters: filters,
      status: status
    }
  }
}
export function changeExternalCourse(filters ={}, status = "loading", counter = 1) {
	return dispatch => dispatch(changeExternalCourseAction(filters, status, counter));
}
export function selectExternalCourse(gets) {

	return dispatch => externalCourseService.selectExternalCourse(gets, res => {
		if (200 === res.status) {
			dispatch({
				type: TrainingConstants.ActionTypes.SELECTEXTERNALCOURSE,
				payload: {
					status: "loaded",
					data: res.data
				}
			});
		}else{
			dispatch(changeExternalCourseAction({}, "error", 0));
		}
	}, err => dispatch(changeExternalCourseAction({}, "error", 0)))
}
export function updateExternalCourse(puts, index, callback) {
	return dispatch => externalCourseService.updateExternalCourse(puts, res => {
		if (res.data.Success) {
			dispatch({
				type: TrainingConstants.ActionTypes.UPDATEEXTERNALCOURSE,
				payload: {
					value: puts,
					index: index
				}
			});
		}
		if ("function" === typeof callback) {
			callback(res);
		}
	})
}


// newcomer-training





// WEBPACK FOOTER //
// ./src/actions/training-actions.js